export const baseUri = process.env.VUE_APP_BACKEND_BASE_URI
// export const baseUri = 'https://o2o-gwapi-devqa.campusbook.co.kr/v2/'
export const universityName = process.env.VUE_APP_UNIVERSITY_NAME
// export const universityName = '경희대학교 출판문화원'

export const universityLogoUrl =
  process.env.VUE_APP_UNIVERSITY_LOGO_URL ||
  'https://e-alice-public.s3.ap-northeast-2.amazonaws.com/resources/cmm/logo/hufs.png'
export const universityAddress = process.env.VUE_APP_UNIVERSITY_ADDRESS
export const universityCopyRight = process.env.VUE_APP_UNIVERSITY_COPY_RIGHT
export const useAliceLogo = process.env.VUE_APP_USE_ALICE_LOGO
//// ysPress customization variables
export const hideSelfbook = process.env.VUE_APP_HIDE_SELFBOOK
// changes /store header text to custom string
export const ysHeaderText = process.env.VUE_APP_YS_HEADER_TEXT
// changes categories -> textbooks
export const hideCategories = process.env.VUE_APP_HIDE_CATEGORIES
// export const hideCategories = true
// custom banner that links to paperBook sales website
export const ysShowBanner = process.env.VUE_APP_YS_SHOW_BANNER
// join/step2 mobile phone auth text2
export const showPhoneText = process.env.VUE_APP_SHOW_PHONE_TEXT
// hides 종이책 & POD 상품 boxes in /cart & [POD],[PAPER] tags in /bookDetail
export const hidePaperBook = process.env.VUE_APP_HIDE_PAPER_BOOK
// show PayPal / 엑심베이 / inicis payment options in /cart/delivery_info
export const globalPayment = process.env.VUE_APP_SHOW_GLOBAL_PAYMENT
// export const globalPayment = true

export const showPopup = process.env.VUE_APP_SHOW_POPUP
// export const showPopup = true
// show popup / 이벤트 팝업창 / 2021-02-05 임시추가

export const hakji = process.env.VUE_APP_SHOW_HAKJI
// hakji / 학지사용 / 2021-02-18 임시추가

export const sentryDSN = process.env.VUE_APP_SENTRY_DSN

export const isHideEnote = process.env.VUE_APP_HIDE_E_NOTE

export const isGlobalDelivery = process.env.VUE_APP_GLOBAL_DELIVERY
// export const isGlobalDelivery = true
export const isNiaMode = false
export const isKhu = process.env.VUE_APP_IS_KHU
// export const isKhu = true
// 니아
// export const isCoupon = true
export const isCoupon = process.env.VUE_APP_IS_COUPON
// // ***************개발***************//
// 쿠폰 관리
